import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

/**
 * Rich Text Editor component using TinyMCE
 * 
 * @param {Object} props - Component props
 * @param {string} props.value - The current value of the editor
 * @param {Function} props.onChange - Function to call when content changes
 * @param {string} props.label - Label for the editor
 * @param {string} props.error - Error message to display
 * @param {boolean} props.touched - Whether the field has been touched
 * @param {number} props.height - Height of the editor in pixels
 * @param {string} props.placeholder - Placeholder text
 */
const RichTextEditor = ({
  value,
  onChange,
  label,
  error,
  touched,
  height = 400,
  placeholder = '',
  id = 'rich-text-editor'
}) => {
  // TinyMCE editor configuration
  const editorConfig = {
    height,
    menubar: true,
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
    ],
    toolbar: 'undo redo | formatselect | ' +
      'bold italic backcolor | alignleft aligncenter ' +
      'alignright alignjustify | bullist numlist outdent indent | ' +
      'removeformat | help',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
    placeholder
  };

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={id} className="label">
          {label}
        </label>
      )}
      <Editor
        id={id}
        apiKey="d2czbzhfv5ddpgx4rqa5h86f051pmo4mqzmxdpd2pr01x7me"
        value={value}
        init={editorConfig}
        onEditorChange={onChange}
      />
      {error && touched && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default RichTextEditor;
